export const PlayDefaults = {
  interval: 5000,
  period: 25,
}
